import { render, staticRenderFns } from "./VehicleExpensesTable.vue?vue&type=template&id=2f96edbc&"
import script from "./VehicleExpensesTable.vue?vue&type=script&lang=js&"
export * from "./VehicleExpensesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports